<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--private"></div>
      <div class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators">
          <div
            class="navigator"
            @click="goTo(0)"
            :class="{
              'navigator--active':
                currentPage === 0 || currentPage === 1 || currentPage === 2,
            }"
          >
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addPrivateCostumerModal.${"details"}`) }}</div>
          </div>
          <div
            class="navigator"
            @click="goTo(1)"
            :class="{
              'navigator--active': currentPage === 1 || currentPage === 2,
            }"
          >
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addPrivateCostumerModal.${"contact"}`) }}</div>
          </div>
          <div
            class="navigator"
            @click="goTo(2)"
            :class="{ 'navigator--active': currentPage === 2 }"
          >
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addPrivateCostumerModal.${"image"}`) }}</div>
          </div>
        </div>

        <form class="add__form" @submit.prevent>
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <transition name="fade" mode="out-in">

                <!-- PAGE 0: Details -->
                <div class="details" key="0" v-if="currentPage === 0">
                  <div class="form__row">
                    <div class="form__field form__field--double">
                      <VSelect
                        :options="genders"
                        :reduce="(gender) => gender.id"
                        :placeholder="$t(`addPrivateCostumerModal.gender`)" 
                        label="name"
                        v-model="privateDetails.gender"
                        class="select select--default"
                        :class="{ 'select--error': genderHasError }"
                      />
                      <div class="form__error" v-if="genderHasError">
                        {{ $t(`addPrivateCostumerModal.${"genderErrorMsg"}`) }}
                      </div>
                    </div>
                    <div class="form__field form__field--double">
                      <VSelect
                        :options="titles"
                        :reduce="(title) => title.id"
                        :placeholder="$t(`addPrivateCostumerModal.title`)" 
                        label="name"
                        v-model="privateDetails.titleId"
                        class="select select--default"
                      />
                    </div>
                  </div>

                  <div class="form__field" v-if="isAddingMember">
                    <VSelect
                      class="select select--default"
                      :options="familyStatuses"
                      :reduce="(status) => status.id"
                      label="name"
                      :placeholder="$t(`addPrivateCostumerModal.relation`)" 
                      v-model="privateDetails.familyStatusId"
                    />
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                      :placeholder="`${$t('addPrivateCostumerModal.firstName')} *`" 
                      v-model="privateDetails.firstName"
                      :class="{ 'input--error': firstNameHasError }"
                    />
                    <div class="form__error" v-if="firstNameHasError">
                      {{ firstNameErrorPlaceholder }}
                    </div>
                  </div>

                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                       :placeholder="`${$t('addPrivateCostumerModal.lastName')} *`" 
                      v-model="privateDetails.lastName"
                      :class="{ 'input--error': lastNameHasError }"
                    />
                    <div class="form__error" v-if="lastNameHasError">
                      {{ lastNameErrorPlaceholder }}
                    </div>
                  </div>

                  <div class="form__row">
                    <div class="form__field form__field--double">
                      <Datepicker
                        class="input input--default"
                        :class="{ 'input--error': birthdayHasError }"
                        :config="statics.datePickerConfig"
                         :placeholder="`${$t('addPrivateCostumerModal.birthdate')} *`"
                        v-model="privateDetails.birthday"
                      />
                      <div class="form__error" v-if="birthdayHasError">
                        {{ $t(`addPrivateCostumerModal.${"birthdateErrorMsg"}`) }}
                      </div>
                    </div>
                    <div class="form__field form__field--double">
                      <VSelect
                        :options="languages"
                        :reduce="(language) => language.id"
                        :placeholder="`${$t('addPrivateCostumerModal.language')} *`"
                        label="name"
                        v-model="privateDetails.language"
                        class="select select--default"
                        :class="{ 'select--error': languageHasError }"
                      />
                      <div class="form__error" v-if="languageHasError">
                        {{ $t(`addPrivateCostumerModal.${"languageErrorMsg"}`) }}
                      </div>
                    </div>
                  </div>

                  <div class="form__row">
                    <div class="form__field form__field--double">
                      <input
                        type="text"
                        class="input input--default"
                       :placeholder="`${$t('addPrivateCostumerModal.street')} *`"
                        v-model="privateAddress[0].street"
                        :class="{ 'input--error': streetHasError }"
                      />
                      <div class="form__error" v-if="streetHasError">
                        {{ $t(`addPrivateCostumerModal.${"streetErrorMsg"}`) }}
                      </div>
                    </div>
                    <div class="form__field">
                      <input
                        type="text"
                        class="input input--default input--nr"
                        placeholder="Nr."
                        v-model="privateAddress[0].number"
                      />
                    </div>
                  </div>

                  <div class="form__row">
                    <div class="form__field form__field--double">
                      <input
                        type="text"
                        class="input input--default"
                        :placeholder="`${$t('addPrivateCostumerModal.zip')} *`"
                        v-model="privateAddress[0].zip"
                        :class="{ 'input--error': zipHasError }"
                      />
                      <div class="form__error" v-if="zipHasError">
                        {{ zipCodePlaceholder }}
                      </div>
                    </div>
                    <div class="form__field form__field--double">
                      <VSelect
                        v-if="zipCodeData.length > 1"
                        :options="zipCodeData"
                        :reduce="(city) => city.city"
                        :placeholder="`${$t('addPrivateCostumerModal.city')} *`"
                        label="city"
                        v-model="privateAddress[0].city"
                        class="select select--default"
                        :class="{ 'select--error': cityHasError }"
                      />
                      <div
                        v-else-if="zipCodeData.length"
                        class="input input--default input--readonly"
                        :class="{ 'input--error': cityHasError }"
                      >
                        {{ privateAddress[0].city }}
                      </div>
                      <input
                        v-else-if="!zipCodeData.length"
                        type="text"
                        class="input input--default"
                        :placeholder="`${$t('addPrivateCostumerModal.city')} *`"
                        v-model="privateAddress[0].city"
                        :class="{ 'input--error': cityHasError }"
                      />
                      <div class="form__error" v-if="cityHasError">
                        {{ $t(`addPrivateCostumerModal.${"cityErrorMsg"}`) }}
                      </div>
                    </div>
                  </div>

                  <div class="form__field" v-if="isAddingMember">
                    <div class="input input--default input--readonly">
                      {{ customer?.team?.name }}
                    </div>
                  </div>
                  <div class="form__field" v-else>
                    <VSelect
                      :options="teams"
                      :reduce="(team) => team.id"
                       :placeholder="`${$t('addPrivateCostumerModal.teams')} *`"
                      label="name"
                      v-model="privateDetails.teamId"
                      class="select select--default"
                      @update:modelValue="getTeamAgents(privateDetails.teamId)"
                      :class="{ 'select--error': teamHasError }"
                    />
                    <div class="form__error" v-if="teamHasError">
                      {{ $t(`addPrivateCostumerModal.${"teamErrorMsg"}`) }}
                    </div>
                  </div>

                  <div class="form__field" v-if="privateIsEdit && showAgentsField">
                    <VSelect
                      :options="agents"
                      :reduce="(agent) => agent.id"
                       :placeholder="`${$t('addPrivateCostumerModal.agents')} *`"
                      v-model="customerAgent"
                      label="fullName"
                      class="select select--default"
                    />
                  </div>
                </div>

                <!-- PAGE 1: Contact -->
                <div class="contact" key="1" v-else-if="currentPage === 1">
                  <div class="form__field">
                    <div
                      class="form__input-wrapper"
                      v-for="(email, index) in customerEmails"
                      :key="index"
                    >
                      <input
                        type="text"
                        class="input input--default"
                        placeholder="E-mail"
                        @input="validateEmail($event, index)"
                        :value="email.email"
                        :class="{ 'input--error': email.hasError }"
                      />
                      <div
                        class="form__add"
                        v-if="index === 0 && email.email"
                        @click="addInput('email')"
                      ></div>
                      <div
                        class="form__remove"
                        v-else-if="index !== 0"
                        @click="removeInput('email', email.id, index)"
                      ></div>
                      <div class="form__error" v-if="email.hasError">
                        {{ email.errorPlaceholder }}
                      </div>
                    </div>
                  </div>

                  <div class="form__field form__field--prefix">
                    <div
                      class="form__row"
                      v-for="(phone, index) in customerPhones"
                      :key="index"
                    >
                      <div class="form__input-wrapper">
                        <input
                          type="text"
                          class="input input--default"
                           :placeholder="$t(`addPrivateCostumerModal.phone`)"
                          @input="validatePhone($event, index)"
                          :value="phone.phone"
                          :class="{ 'input--error': phone.hasError }"
                        />
                        <div
                          class="form__add"
                          v-if="index === 0 && phone.phone"
                          @click="addInput('phone')"
                        ></div>
                        <div
                          class="form__remove"
                          v-else-if="index !== 0"
                          @click="removeInput('phone', phone.id, index)"
                        ></div>
                        <div class="form__error" v-if="phone.hasError">
                          {{ phone.errorPlaceholder }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form__field">
                    <VSelect
                      :options="countries"
                      :reduce="(country) => country.code"
                      placeholder="Nationalitat"
                      label="name"
                      v-model="privateContact.countryCode"
                      class="select select--default"
                    />
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                      placeholder="Beruf"
                      v-model="privateContact.occupation"
                    />
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                      placeholder="Arbeitgeber"
                      v-model="privateContact.employer"
                    />
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                      placeholder="AHV Nr."
                      v-model="privateContact.ahvNr"
                    />
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                      placeholder="IBAN"
                      v-model="privateBank.account"
                    />
                  </div>
                  <div class="form__field">
                    <input
                      type="text"
                      class="input input--default"
                      placeholder="Bankname"
                      v-model="privateBank.name"
                    />
                  </div>
                </div>

                <!-- PAGE 2: Image -->
                <div class="logo" key="2" v-else-if="currentPage === 2">
                  <div class="add__avatar">
                    <img v-if="userImage" :src="userImage" alt="" ref="userImageRef" />
                    <div v-else class="add__avatar-empty">
                      <img
                        class="add__avatar-empty"
                        src="../assets/icons/default/Bold 2px-person-white.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="add__upload-text">
                    {{ $t(`addPrivateCostumerModal.${"uploadText"}`) }}
                  </div>
                  <div class="add__upload-wrapper">
                    <button
                      type="button"
                      class="button button--default button--upload"
                      @click="uploadFileRef.click()"
                    >
                      {{ $t(`addPrivateCostumerModal.${"uploadBtn"}`) }}
                    </button>
                    <input
                      ref="uploadFileRef"
                      type="file"
                      class="add__upload"
                      @change="uploadImage($event)"
                    />
                  </div>
                </div>

              </transition>
            </div>
          </transition>
        </form>
      </div>

      <div
        v-if="isRequesting"
        class="modal__button modal__button--submit button button--default button--loading"
      ></div>
      <button
        v-else
        type="button"
        class="modal__button modal__button--submit button button--default"
        @click="currentPage !== 2 ? goForward() : createCustomer()"
      >
        <span v-if="currentPage === 2">{{ $t(`addPrivateCostumerModal.${"save"}`) }}</span>
        <span v-else>{{ $t(`addPrivateCostumerModal.${"next"}`) }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import { useI18n } from 'vue-i18n';   

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();
defineOptions({
  name: "AddPrivateModal",
});

const store = useStore();
const route = useRoute();
const router = useRouter();

// ─── Template Refs ────────────────────────────────────────────────────────────
const uploadFileRef = ref(null);
const userImageRef = ref(null);

// ─── Primitive State ──────────────────────────────────────────────────────────
const currentPage = ref(0);
const formLoading = ref(false);
const isRequesting = ref(false);
const userImage = ref("");
const file = ref("");
const editingCustomer = ref("");

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// ─── Error Flags ──────────────────────────────────────────────────────────────
const genderHasError = ref(false);
const firstNameHasError = ref(false);
const lastNameHasError = ref(false);
const birthdayHasError = ref(false);
const languageHasError = ref(false);
const streetHasError = ref(false);
const zipHasError = ref(false);
const cityHasError = ref(false);
const teamHasError = ref(false);

const firstNameErrorPlaceholder = ref("");
const lastNameErrorPlaceholder = ref("");
const zipCodePlaceholder = ref("");

const specificErrors = ref([]);

// ─── Agents ───────────────────────────────────────────────────────────────────
const agents = ref(null);
const customerAgent = ref(null);
const customerInitialTeam = ref(null);
const showAgentsField = ref(false);

// ─── Form Data ────────────────────────────────────────────────────────────────
const privateDetails = reactive({
  gender: "",
  titleId: "",
  firstName: "",
  lastName: "",
  birthday: moment(new Date()).format("YYYY-MM-DD"),
  language: "",
  familyStatusId: "",
  teamId: "",
});

const privateAddress = reactive([
  {
    id: "",
    street: "",
    number: "",
    city: "",
    zip: "",
    postBox: "",
  },
]);

const privateContact = reactive({
  countryCode: "",
  ahvNr: "",
  occupation: "",
  employer: "",
});

const privateBank = reactive({
  name: "",
  account: "",
  bankId: "",
  address: "",
});

const customerEmails = ref([
  { id: "", email: "", hasError: false, errorPlaceholder: "" },
]);

const customerPhones = ref([
  {
    id: "",
    prefix: "",
    phone: "",
    hasError: false,
    errorPlaceholder: "",
    prefixHasError: false,
    prefixErrorPlaceholder: "",
  },
]);

// ─── Vuex Getters ─────────────────────────────────────────────────────────────
const customerForms = computed(() => store.getters.customerForms);
const customer = computed(() => store.getters.customer);
const privateIsEdit = computed(() => store.getters.privateIsEdit);
const privateToEdit = computed(() => store.getters.privateToEdit);
const isAddingMember = computed(() => store.getters.isAddingMember);
const isAddingPotentialCustomer = computed(() => store.getters.isAddingPotentialCustomer);
// const loggedUser = computed(() => store.getters.loggedUser);

// ─── Derived Computed Lists ───────────────────────────────────────────────────
const familyStatuses = computed(() => customerForms.value?.family_statuses || []);
const genders = computed(() => customerForms.value?.genders || []);
const titles = computed(() => customerForms.value?.titles || []);
const languages = computed(() => customerForms.value?.languages || []);
const teams = computed(() => customerForms.value?.teams || []);
const countries = computed(() => customerForms.value?.countries || []);

const zipCodeData = computed({
  get() {
    return store.state.zipCodes.zipCodeData;
  },
  set(value) {
    store.commit("setZipCodeData", value);
  },
});

// ─── Watchers ─────────────────────────────────────────────────────────────────
watch(
  () => privateDetails.teamId,
  (value) => {
    teamHasError.value = !value;
  }
);

watch(
  () => privateDetails.gender,
  (value) => {
    genderHasError.value = !value;
  }
);

watch(
  () => privateDetails.firstName,
  (value) => {
    if (value) {
      firstNameHasError.value = false;
      firstNameErrorPlaceholder.value = "";
    } else {
      firstNameErrorPlaceholder.value =  t("addPrivateCostumerModal.firstNameErrorMsg");
      firstNameHasError.value = true;
    }
  }
);

watch(
  () => privateDetails.lastName,
  (value) => {
    if (value) {
      lastNameHasError.value = false;
      lastNameErrorPlaceholder.value = "";
    } else {
      lastNameErrorPlaceholder.value = t("addPrivateCostumerModal.lastNameErrorMsg");
      lastNameHasError.value = true;
    }
  }
);

watch(
  () => privateDetails.birthday,
  (value) => {
    birthdayHasError.value = !value;
  }
);

watch(
  () => privateDetails.language,
  (value) => {
    languageHasError.value = !value;
  }
);

// Zip watcher — matches Vue2 logic exactly: 1000–9999 is valid
watch(
  () => privateAddress[0].zip,
  async (zip) => {
    if (zip) {
      zipHasError.value = false;
      zipCodePlaceholder.value = "";

      if (Number(zip) >= 1000 && Number(zip) <= 9999) {
        await loadCities(zip);
      } else {
        zipCodeData.value = [];
        privateAddress[0].city = "";
        zipHasError.value = true;
        zipCodePlaceholder.value = t("addPrivateCostumerModal.invalidZip");
      }
    } else {
      privateAddress[0].city = "";
      zipHasError.value = true;
      zipCodePlaceholder.value =  t("addPrivateCostumerModal.zipRequired");
    }
  }
);

watch(
  () => privateAddress[0].city,
  (value) => {
    cityHasError.value = !value;
  }
);

watch(
  () => privateAddress[0].street,
  (value) => {
    streetHasError.value = !value;
  }
);

// specificErrors watcher — mirrors Vue2 watcher fully (page navigation + per-field errors)
watch(specificErrors, (errors) => {
   console.log("Watcher u thirr", errors);
  const errorKeys = errors.map((error) => error.errorKey);

if (errorKeys.includes("email")) {
  currentPage.value = 1;

  errors.forEach((error) => {
    if (error.errorKey === "email") {
      customerEmails.value[error.errorPos].errorPlaceholder =
       t("addPrivateCostumerModal.emailDomainErrorMsg");
      customerEmails.value[error.errorPos].hasError = true;
    }
  });

  // Force Vue to refresh the array
  customerEmails.value = [...customerEmails.value];

} else {
  customerEmails.value.forEach((email) => {
    email.errorPlaceholder = "";
    email.hasError = false;
  });

  customerEmails.value = [...customerEmails.value];
}

  if (errorKeys.includes("phone")) {
    currentPage.value = 1;
    errors.forEach((error) => {
      if (error.errorKey === "phone") {
        customerPhones.value[error.errorPos].errorPlaceholder = error.errorValue;
        customerPhones.value[error.errorPos].hasError = true;
      }
    });
  } else {
    customerPhones.value.forEach((phone) => {
      phone.errorPlaceholder = "";
      phone.hasError = false;
    });
  }

  if (errorKeys.includes("first_name")) {
    currentPage.value = 0;
    firstNameErrorPlaceholder.value = errors.find(
      (error) => error.errorKey === "first_name"
    ).errorValue;
    firstNameHasError.value = true;
  } else {
    firstNameHasError.value = false;
    firstNameErrorPlaceholder.value = "";
  }

  if (errorKeys.includes("last_name")) {
    currentPage.value = 0;
    lastNameErrorPlaceholder.value = errors.find(
      (error) => error.errorKey === "last_name"
    ).errorValue;
    lastNameHasError.value = true;
  } else {
    lastNameHasError.value = false;
    lastNameErrorPlaceholder.value = "";
  }
});

// ─── Methods ──────────────────────────────────────────────────────────────────

const getTeamAgents = async (id) => {
  customerAgent.value = null;

  if (customerInitialTeam.value == id) {
    agents.value = null;
    showAgentsField.value = false;
  } else {
    const result = await store.dispatch("getTeamAgents", id);
    if (result && result.length > 0) {
      agents.value = result.map((agent) => ({
        ...agent,
        fullName: `${agent.first_name} ${agent.last_name}`,
      }));
      showAgentsField.value = true;
    }
  }
};

const closeModal = () => {
  store.commit("setShowAddPrivateModal", false);
  store.commit("setPrivateIsEdit", false);
  store.commit("setIsAddingMember", false);
  store.commit("setIsAddingPotentialCustomer", false);
  zipCodeData.value = [];
};

const goBack = () => {
  currentPage.value--;
  if (currentPage.value < 0) {
    store.commit("setShowAddPrivateModal", false);
    store.commit("setPrivateIsEdit", false);
    store.commit("setShowAddCustomerModal", true);
  }
};

const goTo = (page) => {
  if (page === 1) {
    validateCustomerDetails((state) => {
      if (state) currentPage.value = page;
    });
  } else if (page === 2) {
    validateCustomerDetails((detailsState) => {
      validateCustomerContact((contactState) => {
        if (contactState && detailsState) currentPage.value = page;
      });
    });
  } else {
    currentPage.value = page;
  }
};

const goForward = () => {
  if (currentPage.value < 2) {
    if (currentPage.value === 0) {
      validateCustomerDetails((state) => {
        if (state) currentPage.value++;
      });
    } else if (currentPage.value === 1) {
      validateCustomerContact((state) => {
        if (state) currentPage.value++;
      });
    }
  }
};

const validateCustomerDetails = (callback) => {
  const { firstName, lastName, language, gender, birthday, teamId } = privateDetails;
  const { zip, city, street } = privateAddress[0];

  if (!firstName) {
    firstNameHasError.value = true;
    firstNameErrorPlaceholder.value = t("addPrivateCostumerModal.firstNameErrorMsg");
  } else {
    firstNameHasError.value = false;
    firstNameErrorPlaceholder.value = "";
  }

  if (!lastName) {
    lastNameHasError.value = true;
    lastNameErrorPlaceholder.value = t("addPrivateCostumerModal.lastNameErrorMsg");
  } else {
    lastNameHasError.value = false;
    lastNameErrorPlaceholder.value = "";
  }

  if (!teamId) teamHasError.value = true;
  if (!gender) genderHasError.value = true;
  if (!language) languageHasError.value = true;
  if (!birthday) birthdayHasError.value = true;

  if (!zip) {
    zipHasError.value = true;
    zipCodePlaceholder.value = t("addPrivateCostumerModal.zipRequired");
  }
  if (!city) cityHasError.value = true;
  if (!street) streetHasError.value = true;

  if (
    !firstNameHasError.value &&
    !lastNameHasError.value &&
    !languageHasError.value &&
    !genderHasError.value &&
    !birthdayHasError.value &&
    !zipHasError.value &&
    !streetHasError.value &&
    !cityHasError.value
  ) {
    callback(true);
  }
};

const validateCustomerContact = (callback) => {
  customerEmails.value.forEach((email) => {
    if (email.email) {
      if (!emailRegex.test(email.email.toLowerCase())) {
        email.hasError = true;
        email.errorPlaceholder = t("addPrivateCostumerModal.emailRequired");
      } else {
        email.hasError = false;
        email.errorPlaceholder = "";
      }
    } else {
      email.hasError = false;
      email.errorPlaceholder = "";
    }
  });

  customerPhones.value.forEach((phone) => {
    if (phone.phone) {
      if (!statics.phoneRegex.test(phone.phone)) {
        phone.hasError = true;
        phone.errorPlaceholder = t("addPrivateCostumerModal.phoneRequired");
      } else {
        phone.hasError = false;
        phone.errorPlaceholder = "";
      }
    } else {
      phone.hasError = false;
      phone.errorPlaceholder = "";
    }
  });

  const hasErrors =
    customerEmails.value.some((email) => email.hasError) ||
    customerPhones.value.some(
      (phone) => phone.hasError || phone.prefixHasError
    );

  callback(!hasErrors);
};

const validateEmail = (event, index) => {
  const { value } = event.target;
  customerEmails.value[index].email = value;

  if (!isAddingMember.value) {
    if (customerEmails.value[index].email) {
      customerEmails.value[index].hasError = false;
      customerEmails.value[index].errorPlaceholder = "";

      if (!emailRegex.test(customerEmails.value[index].email.toLowerCase())) {
        customerEmails.value[index].hasError = true;
        customerEmails.value[index].errorPlaceholder = t("addPrivateCostumerModal.invalidEmail");
      }
    }
    // empty email is allowed — no error set
  } else {
    if (
      customerEmails.value[index].email &&
      !emailRegex.test(customerEmails.value[index].email.toLowerCase())
    ) {
      customerEmails.value[index].hasError = true;
      customerEmails.value[index].errorPlaceholder = t("addPrivateCostumerModal.invalidEmail");
    } else {
      customerEmails.value[index].hasError = false;
      customerEmails.value[index].errorPlaceholder = "";
    }
  }

  customerEmails.value = [...customerEmails.value];
};

// const validatePrefix = (value, index) => {
//   customerPhones.value[index].prefix = value;
//   if (!customerPhones.value[index].prefix) {
//     customerPhones.value[index].prefixHasError = true;
//     customerPhones.value[index].prefixErrorPlaceholder = "Invalid prefix";
//   } else {
//     customerPhones.value[index].prefixHasError = false;
//     customerPhones.value[index].prefixErrorPlaceholder = "";
//   }
// };

const validatePhone = (event, index) => {
  const { value } = event.target;
  customerPhones.value[index].phone = value;

  if (!isAddingMember.value) {
    if (customerPhones.value[index].phone) {
      if (!statics.phoneRegex.test(value)) {
        customerPhones.value[index].hasError = true;
        customerPhones.value[index].errorPlaceholder = t("addPrivateCostumerModal.invalidPhone");
      } else {
        customerPhones.value[index].hasError = false;
        customerPhones.value[index].errorPlaceholder = "";
      }
    }
    // empty phone is allowed — no error set
  } else {
    if (
      customerPhones.value[index].phone &&
      !statics.phoneRegex.test(value)
    ) {
      customerPhones.value[index].hasError = true;
      customerPhones.value[index].errorPlaceholder = t("addPrivateCostumerModal.invalidPhone");
    } else {
      customerPhones.value[index].hasError = false;
      customerPhones.value[index].errorPlaceholder = "";
    }
  }

  customerPhones.value = [...customerPhones.value];
};

const addInput = (type) => {
  if (type === "email") {
    customerEmails.value = [
      ...customerEmails.value,
      { id: "", email: "", hasError: false, errorPlaceholder: "" },
    ];
  } else if (type === "phone") {
    customerPhones.value = [
      ...customerPhones.value,
      {
        id: "",
        prefix: "",
        phone: "",
        hasError: false,
        errorPlaceholder: "",
        prefixHasError: false,
        prefixErrorPlaceholder: "",
      },
    ];
  }
};

const removeInput = async (type, id, index) => {
  if (type === "email") {
    if (!id) {
      customerEmails.value.splice(index, 1);
    } else {
      try {
        await store.dispatch("deleteCustomerEmail", id);
        customerEmails.value.splice(
          customerEmails.value.findIndex((email) => email.id === id),
          1
        );
      } catch (err) {
        console.error(err);
      }
    }
  } else if (type === "phone") {
    if (!id) {
      customerPhones.value.splice(index, 1);
    } else {
      try {
        await store.dispatch("deleteCustomerPhone", id);
        customerPhones.value.splice(
          customerPhones.value.findIndex((phone) => phone.id === id),
          1
        );
      } catch (err) {
        console.error(err);
      }
    }
  }
};

const uploadImage = (event) => {
  file.value = event.target.files[0];
  userImage.value = URL.createObjectURL(file.value);
};

const loadCities = async (value) => {
  await store.dispatch("getZipCodeData", value);
  privateAddress[0].zip = value;
  privateAddress[0].city = store.state.zipCodes.zipCodeData[0]?.city || "";
};

const loadFieldsForEdit = (c) => {
  privateDetails.gender = c.gender ? c.gender.id : "";
  privateDetails.teamId = c.team ? c.team.id : "";

  customerInitialTeam.value = c.team ? c.team.id : "";

  privateDetails.titleId = c.title ? c.title.id : "";
  privateDetails.birthday = c.birthday || "";
  privateDetails.firstName = c.first_name || "";
  privateDetails.lastName = c.last_name || "";
  privateDetails.language = c.language ? c.language.id : "";
  privateDetails.familyStatusId = c.family_status ? c.family_status.id : "";

  const addrs = c.customer_addresses;
  privateAddress[0].id = addrs.length ? addrs[0].id : "";
  privateAddress[0].street = addrs.length ? addrs[0].street : "";
  privateAddress[0].postBox = addrs.length ? addrs[0].post_box : "";
  privateAddress[0].zip = addrs.length ? addrs[0].zip : "";
  privateAddress[0].number = addrs.length ? addrs[0].number : "";
  privateAddress[0].city = addrs.length ? addrs[0].city : "";

  customerEmails.value = c.customer_emails.length
    ? c.customer_emails.map((email) => ({
        id: email.id,
        email: email.email,
        hasError: false,
        errorPlaceholder: "",
      }))
    : [{ id: "", email: "", hasError: false, errorPlaceholder: "" }];

  customerPhones.value = c.customer_phones.length
    ? c.customer_phones.map((phone) => ({
        id: phone.id,
        prefix: phone.prefix,
        phone: phone.phone,
        hasError: false,
        errorPlaceholder: "",
        prefixHasError: false,
        prefixErrorPlaceholder: "",
      }))
    : [
        {
          id: "",
          prefix: "",
          phone: "",
          hasError: false,
          errorPlaceholder: "",
          prefixHasError: false,
          prefixErrorPlaceholder: "",
        },
      ];

  privateContact.countryCode = c.country ? c.country.code : "";
  privateContact.occupation = c.occupation || "";
  privateContact.employer = c.employer || "";
  privateContact.ahvNr = c.ahv_number || "";

  userImage.value = c.photo ? c.photo.preview : "";

  privateBank.bankId = c.banks.length ? c.banks[0].id : "";
  privateBank.account = c.banks.length ? c.banks[0].account : "";
  privateBank.name = c.banks.length ? c.banks[0].name : "";
  privateBank.address = c.banks.length ? c.banks[0].address : "";

  if (c.agent_id) {
    customerAgent.value = c.agent_id;
  }
};

const createCustomer = async () => {
  isRequesting.value = true;

  if (privateIsEdit.value) {
    // keep existing photo filename if no new file was uploaded
    // (passed through as-is in the payload below)
  }

  const customer_emails = customerEmails.value[0].email
    ? customerEmails.value.map((email) => ({
        id: email.id,
        email: email.email,
      }))
    : [];

  const customer_phones = customerPhones.value[0].phone
    ? customerPhones.value.map((phone) => ({
        id: phone.id,
        phone: phone.phone,
        prefix: phone.prefix,
      }))
    : [];

  const customerPayload = {
    ...privateDetails,
    ...privateContact,
    ...privateBank,
    file: file.value,
    member_type_id: statics.memberTypes.private,
    customerAddresses: privateAddress[0],
    customer_emails,
    customer_phones,
    customer_status_id: 1,
  };

  try {
    if (privateIsEdit.value) {
      const { id } = await store.dispatch("updateCustomer", {
        ...customerPayload,
        companyId: privateToEdit.value,
        agentId: customerAgent.value,
      });

      if (route.name === "AccountDetails") {
        await store.dispatch("getGlobalCustomer", id);
        store.commit("setCustomerDetails", customer.value);
      }

      store.commit("setToast", {
        display: true,
        type: "success",
        message: t("messages.customerEditedSuccessfully"),
      });
    } else {
      if (isAddingMember.value) {
        const { parent_id } = customer.value;
        const { id } = route.params;

        await store.dispatch("addCustomer", {
          ...customerPayload,
          parentId: parent_id || id,
          teamId: customer.value.team.id,
        });

        await store.dispatch("getGlobalCustomer", id);

        store.commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.memberAddedSuccessfully"),
        });
      } else {
        const { id } = await store.dispatch("addCustomer", customerPayload);

        store.commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.customerAddedSuccessfully"),
        });

        router.push({
          name: "AccountDetails",
          params: { entity: "customer", id },
        });

        if (isAddingPotentialCustomer.value) {
          await store.dispatch("getGlobalCustomer", id);
          store.commit("setCustomerDetails", customer.value);
          store.commit("setShowAddPotentialPolicyModal", true);
        }
      }
    }

    closeModal();
} catch (err) {
  isRequesting.value = false;

  if (err.response?.data) {
    let errors = err.response.data.errors;

    // përdor message vetëm nëse errors nuk ekziston
    if (!errors && err.response.data.message) {
      errors = err.response.data.message;
    }

    specificErrors.value = parseFieldErrors(errors);
    console.log("Errors:", specificErrors.value);
  }
}
};

// ─── Lifecycle ────────────────────────────────────────────────────────────────
onMounted(async () => {
  formLoading.value = true;

  const customer_status_id = 1;
  await store.dispatch("getCustomerForms", { customer_status_id });

  if (privateIsEdit.value) {
    const c = await store.dispatch("getCustomer", privateToEdit.value);
    editingCustomer.value = c;
    loadFieldsForEdit(c);
  }

  if (isAddingMember.value && customer.value) {
    const c = customer.value;
    privateDetails.lastName = c.last_name || "";

    const addrs = c.customer_addresses;
    privateAddress[0].id = addrs.length ? addrs[0].id : "";
    privateAddress[0].street = addrs.length ? addrs[0].street : "";
    privateAddress[0].postBox = addrs.length ? addrs[0].post_box : "";
    privateAddress[0].zip = addrs.length ? addrs[0].zip : "";
    privateAddress[0].number = addrs.length ? addrs[0].number : "";
  }

  formLoading.value = false;
});

// ─── Helpers ──────────────────────────────────────────────────────────────────
const parseFieldErrors = (errors) => {
  if (Array.isArray(errors)) return errors;

  const result = [];

  if (typeof errors === "object" && errors !== null) {
    Object.keys(errors).forEach((key) => {

      let errorKey = key;
      let errorPos = 0;

      // customer_emails.0.email
      const emailMatch = key.match(/^customer_emails\.(\d+)\.email$/);
      if (emailMatch) {
        errorKey = "email";
        errorPos = Number(emailMatch[1]);
      }

      // customer_phones.0.phone
      const phoneMatch = key.match(/^customer_phones\.(\d+)\.phone$/);
      if (phoneMatch) {
        errorKey = "phone";
        errorPos = Number(phoneMatch[1]);
      }

      const messages = Array.isArray(errors[key])
        ? errors[key]
        : [errors[key]];

      messages.forEach((msg) => {
        result.push({
          errorKey,
          errorValue: msg,
          errorPos,
        });
      });
    });
  } else if (typeof errors === "string") {
    result.push({
      errorKey: "global",
      errorValue: errors,
      errorPos: 0,
    });
  }

  return result;
};
</script>